<!-- Input box -->
<div class="input-box">
  <!-- Attachment thumbnails -->
  @if ($hasAttachments()) {
    <div class="attachments">
      <!-- Uploading files: show skeleton -->
      @for (file of $uploadingFiles(); track file.id) {
        <div class="attachment-thumb uploading">
          <wb-button-icon class="attachment-remove" [iconLeft]="'fa-regular fa-xmark'" [tooltip]="'Remove'" (onClick)="onRemoveFile(file.id); $event.stopPropagation()" />
          <div class="skeleton-loading"></div>
        </div>
      }

      <!-- Error files: show error overlay with retry -->
      @for (file of $errorFiles(); track file.id) {
        <div class="attachment-thumb error" (click)="onThumbnailClick(file)">
          <wb-button-icon class="attachment-remove" [iconLeft]="'fa-regular fa-xmark'" [tooltip]="'Remove'" (onClick)="onRemoveFile(file.id); $event.stopPropagation()" />
          <div class="error-overlay">
            <i class="fa-regular fa-rotate-right"></i>
          </div>
        </div>
      }

      <!-- Ready files: images/videos render a thumbnail; other files get a compact icon+name chip -->
      @for (tile of $readyTiles(); track tile.id) {
        @if (tile.isThumbnail) {
          <div class="attachment-thumb ready">
            <wb-button-icon class="attachment-remove" [iconLeft]="'fa-regular fa-xmark'" [tooltip]="'Remove'" (onClick)="onRemoveFile(tile.id); $event.stopPropagation()" />
            <attachment [attachment]="tile.attachment" [deletable]="false" [selectable]="false" [downloadable]="false" [thumbnailHeight]="60" (itemClicked)="onAttachmentClick($event)" />
          </div>
        } @else {
          <div class="attachment-thumb ready file" [title]="tile.name">
            <wb-button-icon class="attachment-remove" [iconLeft]="'fa-regular fa-xmark'" [tooltip]="'Remove'" (onClick)="onRemoveFile(tile.id); $event.stopPropagation()" />
            <i class="file-chip-icon {{ tile.icon }}"></i>
            <div class="file-chip-meta">
              <span class="file-chip-name">{{ tile.name }}</span>
              @if (tile.ext) {
                <span class="file-chip-type">{{ tile.ext }}</span>
              }
            </div>
          </div>
        }
      }
    </div>
  }

  <!-- Textarea -->
  <textarea #textarea class="prompt-textarea" [value]="$text()" placeholder="Describe your task..." [disabled]="$disabled()" [attr.maxlength]="64000" (input)="onTextInput($event)" (keydown)="onKeydown($event)" (paste)="onPaste($event)" rows="1"></textarea>

  <!-- Actions row -->
  <div class="actions-row">
    <!-- Left side: upload + model selector + session context -->
    <div class="actions-left">
      @if ($showAttachment()) {
        <wb-button-icon [iconLeft]="'fa-regular fa-arrow-up-from-bracket'" [tooltip]="'Upload file'" [displayStyle]="ButtonDisplayStyle.Tertiary" [disabled]="$isStreaming() || $disabled()" (onClick)="onUploadClick()" />
      }

      @if ($showSessionContext() && $sessionContext(); as ctx) {
        <div class="session-context-tag">
          <span class="tag-label">{{ ctx.label }}</span>
          <wb-button-icon class="tag-close" [iconLeft]="'fa-regular fa-xmark'" [tooltip]="'Remove context'" [displayStyle]="ButtonDisplayStyle.Tertiary" (onClick)="onRemoveContext()" />
        </div>
      }
    </div>

    <!-- Right side: model selector + action button -->
    <div class="actions-right">
      <!-- Model selector: tier picker beside send. Shows both tiers with the selected one surfaced;
           never a model name. Gated by AIHeavyModel — hidden when the tenant can't use Heavy. -->
      @if ($heavyModelEnabled()) {
        <agent-model-tier-picker [tier]="$modelTier()" [heavyEnabled]="$heavyModelEnabled()" [locked]="$modelLocked()" [disabled]="$disabled()" (tierChange)="onModelTierChanged($event)" />
      }
      @if ($showStopBesideSend()) {
        <wb-button-icon [iconLeft]="'fa-solid fa-stop'" [tooltip]="$stopTooltip()" [displayStyle]="ButtonDisplayStyle.Tertiary" [disabled]="$stopping()" (onClick)="onStop()" />
      }
      @switch ($mode()) {
        @case ('running') {
          <wb-button-icon [iconLeft]="'fa-solid fa-stop'" [tooltip]="'Stop generation'" [displayStyle]="ButtonDisplayStyle.Tertiary" (onClick)="onStop()" />
        }
        @case ('mentioning') {
          <wb-button-icon [iconLeft]="'fa-regular fa-arrow-up'" [tooltip]="'Send message'" [displayStyle]="ButtonDisplayStyle.Primary" [accent]="ButtonAccent.Accent" [disabled]="$disabled()" (onClick)="onSend()" />
        }
        @case ('filled') {
          <wb-button-icon [iconLeft]="'fa-regular fa-arrow-up'" [tooltip]="'Send message'" [displayStyle]="ButtonDisplayStyle.Primary" [accent]="ButtonAccent.Accent" [disabled]="$disabled()" (onClick)="onSend()" />
        }
        @default {
          <wb-button-icon [iconLeft]="'fa-regular fa-arrow-up'" [tooltip]="'Send message'" [displayStyle]="ButtonDisplayStyle.Tertiary" [disabled]="true" />
          <!-- <wb-button-icon [iconLeft]="'fa-regular fa-microphone'" [tooltip]="'Voice input'" [displayStyle]="ButtonDisplayStyle.Tertiary" [disabled]="$disabled()" /> -->
        }
      }
    </div>
  </div>
</div>

<!-- Hidden file input -->
<input #fileInput type="file" class="hidden-file-input" [accept]="$acceptedExtensions" multiple (change)="onFileChange($event)" />
